/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum RespiratoryMonitoringInactivateAliases {
  FIELD_RESPIRATORY_MONITORING = 'field-respiratory-monitoring',
  FORM_RESPIRATORY_MONITORING_INACTIVATE = 'form-respiratory-monitoring-inactivate',
  LAYOUT_RESPIRATORY_MONITORING_INACTIVATE = 'layout-respiratory-monitoring-inactivate',
  PANEL_RESPIRATORY_MONITORING_INACTIVATE = 'panel-respiratory-monitoring-inactivate',
  TEXT_AREA_RESPIRATORY_MONITORING = 'text-area-respiratory-monitoring',
}
export { RespiratoryMonitoringInactivateAliases };
